<!-- src/components/FormHeader.vue -->
<template>
  <!-- 
    🛡️ COMPONENT HARDENED: 
    Redundant 'Dashboard' and 'Back' buttons removed per Client Mandate.
    Spacing preserved to maintain structural alignment with Midnight Premium cards.
  -->
  <div class="px-8 sm:px-6 md:px-8 pt-4 sm:pt-6 md:pt-8 pb-0 no-print">
    <div class="max-w-7xl mx-auto">
      <!-- Minimal divider kept for card separation -->
      <div class="border-b border-gray-100 pb-4"></div>
    </div>
  </div>
</template>

<script setup>
/* 🛡️ ESLINT CLEANSE: Unused icons and props removed to ensure build success */
</script>